<template>
  <div class="s5">
    <div class="container">
      <img src="@/assets/home/s5/title.png" class="title" alt="" />
      <div class="img-wrapper">
        <div class="item" v-for="item in iconList" :key="item.id">
          <img :src="item.icon" alt="" class="item-img" />
          <img :src="item.title" alt="" class="item-title" />
          <p>
            {{ item.text }}
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      iconList: [
        {
          id: 1,
          icon: require("@/assets/home/s5/1.png"),
          title: require("@/assets/home/s5/11.png"),
          text: "联合创始人具备18年咖啡奶茶供应链的实力，期参股公司专业为多个大型连锁品牌进行饮品的研发、原材料供应、店员的培训等工作，具备强大的产品研发能力、原料的渠道优势、专业的培训体系，确保口味领先同时降低出品成本。",
        },
        {
          id: 2,
          icon: require("@/assets/home/s5/2.png"),
          title: require("@/assets/home/s5/22.png"),
          text: "创始团队已经服务过50家品牌近万个门店的数字化管理与会员营销服务，同时也是抖音本地生活服务商，抖音ISV系统服务商，拥有较强的抖音运营能力、团购打品能力、达人组织能力、培训输出能力，助力门店借助自媒体平台打爆同城快速出圈。",
        },
        {
          id: 3,
          icon: require("@/assets/home/s5/3.png"),
          title: require("@/assets/home/s5/33.png"),
          text: "创始团队拥有丰富的文创IP资源及品牌资源，将提供全国知名文创IP+咖啡的联名营销活动，同时提供城市礼物的营销策略，协助洽谈当地博物、文旅等影响力的等资源联名，助力门店借助大IP获取同城流量，让门店热度持续增长。",
        },
      ],
    };
  },
};
</script>

<style lang="less" scoped>
.s5 {
  width: 100%;
  height: 808px;
  background: #231815;
  padding-top: 80px;
  box-sizing: border-box;
  margin: 0 auto;
  .container {
    // width: 1600px;
    height: 591px;
    margin: 0 auto;
    text-align: left;
    .title {
      width: 446px;
      height: 54.55px;
    }
    .img-wrapper {
      // width: 1600px;
      height: 501px;
      display: flex;
      justify-content: space-between;
      position: relative;
      margin: 0 auto;
      margin-top: 40px;
      .item {
        height: 473px;
        text-align: center;
        p {
          margin-top: 20px;
          text-align: justify;
          color: #fff;
          font-size: 18px;
          line-height: 28px;
        }
      }
    }
  }
}

@media screen {
  @media (min-width: 1617px) {
    .s5 {
      min-width: 1600px;
    }
    .container {
      width: 1600px;
      .img-wrapper {
        width: 1600px;
        .item {
          width: 380px;
        }
        .item-title {
          width: 380.5px;
        }
        .item-img {
          width: 342px;
          height: 249px;
        }
      }
    }
  }

  @media (min-width: 1201px) and (max-width: 1616px) {
    .container {
      width: 90%;
      .img-wrapper {
        width: calc(100% - 17px);
        .item {
          width: calc((100% - 17px) * 0.2375);
          .item-img {
            width: 90%;
          }
          .item-title {
            width: 100%;
          }
        }
      }
    }
  }

  @media (max-width: 1200px) {
    .s5 {
      width: 1200px;
    }
    .container {
      width: 1083px;
      margin: 0 auto;
      text-align: center;
      .img-wrapper {
        width: 1083px;

        .item {
          text-align: center;
          .item-title {
            width: 267px;
          }
          .item-img {
            width: 243px;
            height: 177px;
          }
          p {
            width: 248px;
            margin: 0 auto;
          }
        }
      }
    }
  }
}
</style>
